import React, { useState } from 'react';
import { Button, Form, Input, Modal, notification } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import FormLabel from '../../../components/FormLabel';
import NormalFormLabel from '../../../components/NormalFormLabel';
import CustomSelect from '../../../components/CustomSelect';
import { useMutation } from '@tanstack/react-query';
import { validatePassword, validatePhoneNumber, validateUsername } from '../../../utils/validate';
import { createMemberRequest } from '../../../services/memberRequest';

const ThemNguoiDung = ({
  open,
  setOpen,
  refetchDataMembers,
  dataPartnersOption,
  dataPermissionGroupsOption,
  dataStatusAccountOption,
}) => {
  const [form] = Form.useForm();
  const typeAccount = Form.useWatch('type', form);
  const handleCancel = () => {
    setOpen(false);
  };

  // handle submit form
  const { mutate: mutateCreateMember, isPending: isLoadingCreateMember } = useMutation({
    mutationFn: createMemberRequest,
    onSuccess: async (data) => {
      if (data?.status) {
        notification.success({
          message: 'Thêm mới người dùng thành công!',
        });
        refetchDataMembers();
        form.resetFields();
        setOpen(false);
      } else {
        notification.error({
          message: data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (data) => {
    mutateCreateMember(data);
  };

  return (
    <Modal title="Thêm người dùng" open={open} onCancel={handleCancel} footer={null} width={840}>
      <Form layout="vertical" form={form} onFinish={handleSubmitForm} requiredMark={false}>
        <Form.Item
          label={<FormLabel text="Tên người dùng" />}
          name="fullname"
          rules={[{ required: true, message: 'Vui lòng nhập tên người dùng' }]}
        >
          <Input allowClear placeholder="Nhập tên người dùng" />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Loại tài khoản" />}
          name="type"
          rules={[{ required: true, message: 'Vui lòng chọn loại tài khoản' }]}
        >
          <CustomSelect
            placeholder="Chọn loại tài khoản..."
            options={[
              { value: 1, label: 'Nội bộ' },
              { value: 2, label: 'Đối tác' },
            ]}
          />
        </Form.Item>

        {typeAccount === 2 && (
          <Form.Item
            label={<FormLabel text="Đối tác" />}
            name="partner_id"
            rules={[{ required: typeAccount === 2, message: 'Vui lòng chọn đối tác' }]}
          >
            <CustomSelect placeholder="Chọn đối tác..." options={dataPartnersOption} />
          </Form.Item>
        )}

        <Form.Item
          label={<FormLabel text="Nhóm quyền" />}
          name="role"
          rules={[{ required: true, message: 'Vui lòng chọn nhóm quyền' }]}
        >
          <CustomSelect placeholder="Chọn nhóm quyền..." options={dataPermissionGroupsOption} />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Tên đăng nhập" />}
          name="username"
          rules={[
            { required: true, message: 'Vui lòng nhập tên đăng nhập' },
            () => ({
              validator(_, value) {
                if (value && !validateUsername(value)) {
                  return Promise.reject(
                    new Error('Tên đăng nhập phải đúng định dạng viết liền không dấu, không có ký tự đặc biệt')
                  );
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input allowClear placeholder="Nhập tên đăng nhập..." />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Mật khẩu" />}
          name="password"
          rules={[
            { required: true, message: 'Vui lòng nhập mật khẩu' },
            () => ({
              validator(_, value) {
                if (value && !validatePassword(value)) {
                  return Promise.reject(
                    new Error(
                      'Mật khẩu phải có ít nhất 8 ký tự, bao gồm ít nhất một chữ thường, một chữ hoa, một số và một ký tự đặc biệt'
                    )
                  );
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input allowClear placeholder="Nhập mật khẩu..." />
        </Form.Item>

        <Form.Item
          label={<NormalFormLabel text="Email" />}
          name="email"
          rules={[{ type: 'email', message: 'Email không đúng định dạng' }]}
        >
          <Input allowClear placeholder="Nhập email..." />
        </Form.Item>

        <Form.Item
          label={<NormalFormLabel text="Số điện thoại" />}
          name="phone"
          rules={[
            () => ({
              validator(_, value) {
                if (value && !validatePhoneNumber(value)) {
                  return Promise.reject(new Error('Số điện thoại không đúng định dạng'));
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input allowClear placeholder="Nhập số điện thoại.." />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Trạng thái" />}
          name="is_active"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
          initialValue={0}
        >
          <CustomSelect placeholder="Chọn trạng thái..." options={dataStatusAccountOption} />
        </Form.Item>

        <div className="flex justify-end gap-3">
          <Button onClick={handleCancel}>
            <CloseOutlined /> Hủy bỏ
          </Button>
          <Button loading={isLoadingCreateMember} type="primary" htmlType="submit">
            <SaveOutlined /> Lưu lại
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ThemNguoiDung;
